
export interface QuickRange {
  label: string;
  calculate: () => { from: Date; to: Date };
}